export default {
  templates: [],
  newTemplate: {
    hasUprn: false,
    hasAddress: false,
    hasBuildingTypes: false,
    hasOwner: false,
    hasAgent: false
  },
  newTemplateFiles: [],
  bps: [],
  attachingTemplatesByBp: {},
  invitations: [],
  totalPages: 1
}
